import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=d6e8f1b0&scoped=true&"
import script from "./Brands.vue?vue&type=script&lang=js&"
export * from "./Brands.vue?vue&type=script&lang=js&"
import style0 from "./Brands.vue?vue&type=style&index=0&id=d6e8f1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e8f1b0",
  null
  
)

export default component.exports